(function ($, Global) {
	var DevisPage = function (model) {
		this.model = model;
	};

	DevisPage.prototype.initEvents = function () {
		this.publishers();
	}

	DevisPage.prototype.publishers = function () {
		var self = this;

		$(document).ready(function () {
			onReady.call(this)
        });

		$(document).on('submit', '.form-devis', function (e) {
            onSubmitFormDevis.call(this, e, self)
        });

		$(document).on('change', '[name="Organisation_pays"], [name="Facturation_pays"]', function (e) {
            onChangePays.call(this, e, self)
        });

        $(document).on('change', '[name="Facturation_tvaAssujetti"]', function (e) {
            onChangeTva.call(this, e)
        });

		$(document).on('change', '.publication-item input[name^="Bouquet_nom"]', function (e) {
            onChangeBouquet.call(this, e)
        });

		$(document).on('click', '#btnNewReader', function (e) {
            onClickBtnNewReader.call(this, e)
        });

		$(document).on('click', '.btn-remove-reader', function (e) {
            onClickBtnRemoveReader.call(this, e)
        });
	}

	DevisPage.prototype.getData = function () {
	    var Destinataires = [];
	    var Bouquets = [];
		var data = {};

        $("form.form-devis :input").not('[name^=Destinataire_], [name^=Bouquet_nom], [name^=Bouquet_nb]').each(function () {
			var $input = $(this);
            
			if ($input.attr('type') == 'Radio' && !$input.prop('checked')) return;

            if ($input.attr('type') == 'CheckBox') {
				data[$input.attr("name")] = $input.is(':checked');
			} else {
				data[$input.attr("name")] = $input.val();
			}
		});

		$(".form-destinataires div.form").each(function () {
			var destinataire = {};

			destinataire['Destinataire_civilite'] = $(this).find(':input[name^=Destinataire_civilite]:checked').val();
			destinataire['Destinataire_nom'] = $(this).find(':input[name^=Destinataire_nom]').val();
			destinataire['Destinataire_prenom'] = $(this).find(':input[name^=Destinataire_prenom]').val();
			destinataire['Destinataire_email'] = $(this).find(':input[name^=Destinataire_email]').val();
			Destinataires.push(destinataire);
		});

		$(".announce input:checked").each(function () {
			var val = parseInt($(".announce :input[name=" + $(this).attr('name').replace('Bouquet_nom', 'Bouquet_nb') + "]").val(), 10);

			bouquetCallback($(this), val, Bouquets);
		});

		$(".announce input[type=hidden]").each(function () {
			var val = parseInt($(":input[name=" + $(this).attr('name').replace('Bouquet_nom', 'Bouquet_nb') + "]").val(), 10);

			bouquetCallback($(this), val, Bouquets);
		});

		data['Destinataires'] = Destinataires;

		return data;
	}

    function onReady() {
        if ($('#btnNewReader').exists()) {
            var limit = $('#btnNewReader').data('limit');

            if ($('.form-destinataires .form').length >= limit) {
                $('#btnNewReader').hide();
            }
        }
    }

    function onSubmitFormDevis(e, instance) {
        e.preventDefault();
        var data = {};
        var $submit = $('.form-devis input[type="submit"]');
        var $form = $('form.form-devis');
        $.Topic('loader-show').publish('.page');

        data = instance.getData();
        data['Contact_email'] = data['Contact_email'].trim();
        data['Facturation_email'] = data['Facturation_email'].trim();
        if (data['Bouquet_Default']) {
            var nbLecteursParBouquets = {};
            nbLecteursParBouquets[Number(data['Bouquet_Default'])] = Number($(this).find(':input[name^=Bouquet_nb_' + data['Bouquet_Default'] + ']').val())
            data['NbLecteursParBouquet'] = nbLecteursParBouquets;
        }

        instance.model.commande(data, $form, function () {
            $.resetErrors($form);
            $submit.disabled(true);
        });
    }

    function onChangePays(e, instance) {
        var val = 0;
        var $infoTva = $('.info-tva');

        if ($('[name="Facturation_adresseDifferente"]').prop('checked')) {
            val = $('[name="Facturation_pays"]').val() || $('[name="Organisation_pays"]').val();
        } else {
            val = $('[name="Organisation_pays"]').val();
        }

        if ($infoTva.exists()) {
            instance.model.checkTva(val, function (data) {
                $('#tvaPrefix').val(data.data);
                $('.info-tva')[data.data !== "" ? 'removeClass' : 'addClass']('hidden');
            });
        }
    }

    function onChangeTva(e) {
        var value = $(this).val();
        var $tvaContent = $('#tvaContent');
        value === 'oui' ? $tvaContent.removeClass('hidden') : $tvaContent.addClass('hidden');
    }

    function onChangeBouquet(e) {
        var $this = $(this);
        var $parent = $this.closest('.publication-item');
        var isChecked = $this.is(':checked')
        var action = isChecked ? 'removeClass' : 'addClass';
        var $checkbox;

        $parent.find('.nb-readers')[action]('hidden');

        if ($this.closest('.list-publications').exists() && isChecked) {
            $checkbox = $('.publication-item').first().find('input[name^="Bouquet_nom"]');
        } else {
            $checkbox = $('.list-publications input[name^="Bouquet_nom"]');
        }

        $checkbox.prop('checked', false).parent().removeClass('check');
        $checkbox.closest('.publication-item').find('.nb-readers').addClass('hidden');
    }

    function onClickBtnNewReader(e) {
        e.preventDefault();
        var tplFormReader = _.template($('#newReaderTemplate').html());
        var nbDest = $('.form-destinataires .form').length + 1;
        var limit = $(this).data('limit');

        if (nbDest >= limit) {
            $(this).hide();
        } else {
            $(this).show();
        }

        $('.form-destinataires .form-text').remove();

        if (!addErrorOnEmptyInput($('.form-destinataires'))) {
            $('.btn-remove-reader').addClass('hidden');
            $('.form-destinataires').append(tplFormReader({
                data: {
                    nb: nbDest
                }
            }));
        }
    }

    function onClickBtnRemoveReader(e) {
        e.preventDefault();
        var $form = $(this).closest('.form');
        var nbDest = $('.form-destinataires .form').length + 1;
        var limit = $(this).data('limit');

        if (nbDest >= limit) {
            $('#btnNewReader').hide();
        } else $('#btnNewReader').show();

        $form.remove();
        $('.btn-remove-reader').last().removeClass('hidden');
    }

	function bouquetCallback($el, elemValue, bouquets) {
		var key = $el.val();
		var bouquet = {};

		bouquet['Key'] = key;
		bouquet['Value'] = elemValue;
		bouquets.push(bouquet);
	}

	function addErrorOnEmptyInput($parent) {
		var tplErrorEmpty = _.template($('#messageErrorEmptyTemplate').html());
		var $emptyInput = $parent.find('input').filter(function () {
			return !this.value;
		});

		$emptyInput.each(function () {
			$(this).closest('.form-group').append(tplErrorEmpty());
		});

		return $emptyInput.length > 0;
	}

	Global.DevisPage = DevisPage;
}(jQuery, window));